<div class="rsx-spinner fa-2x active">
  <div class="rsx-spinner-wrapper">
    <img
      src="/assets/images/icons/logo-5rs.svg"
      alt="Republic Services"
      class="rsx-spinner-icon"
    />
    <svg
      class="loading-circle"
      width="32"
      height="32"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        fill="#004a7c"
        d="M84.7 86c19.9-19.1 20.4-50.8 1.3-70.7S35.2-5.2 15.3 14l5.9 6.1C37.7 4.3 63.9 4.7 79.8 21.2s15.4 42.7-1.1 58.6l6 6.2z"
      />
    </svg>
  </div>
</div>
